import React from 'react';
import { Box, Typography, LinearProgress } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import { useStyles } from './Styles';

const PasswordChecklist = props => {
  const { value, minLength } = props;
  const classes = useStyles();

  const rules = {
    length: {
      valid: value.length >= (minLength || 100),
      message: 'Password has more than ' + minLength + ' characters.'
    },
    specialChar: {
      // eslint-disable-next-line
      valid: /[~`!#$%\^&*@+=\-\[\]\\';,/{}|\\':<>\?\.]/g.test(value),
      message: 'Password has special characters.'
    },
    number: {
      valid: /\d/g.test(value),
      message: 'Password has a number.'
    },
    capital: {
      valid: (function() {
        let i = 0;
        if (value.length === 0) {
          return false;
        }
        while (i < value.length) {
          const character = value.charAt(i);
          if (character === character.toLowerCase()) {
          } else if (character === character.toUpperCase()) {
            return true;
          }
          i++;
        }
        return false;
      })(),
      message: 'Password has a capital letter.'
    }
  };

  const validRules = Object.values(rules).filter(rule => rule.valid).length;
  const totalRules = Object.values(rules).length;
  const passwordStrength = Math.round((validRules / totalRules) * 100);

  const getStrengthInfo = () => {
    if (passwordStrength === 0) return { label: 'Very Weak', color: '#FF0033' };
    if (passwordStrength === 25) return { label: 'Weak', color: '#FF6B33' };
    if (passwordStrength === 50) return { label: 'Medium', color: '#FFCC33' };
    if (passwordStrength === 75) return { label: 'Strong', color: '#99CC33' };
    if (passwordStrength === 100) return { label: 'Very Strong', color: '#4BCA81' };
    return { label: 'Very Weak', color: '#FF0033' };
  };

  const strengthInfo = getStrengthInfo();

  return (
    <Box
      className={classes.checklistMargin}
      display="flex"
      flexDirection="Column"
    >
      <Typography className={classes.passwordStrength}>
        Password Strength: 
        <span style={{ color: strengthInfo.color }}> {strengthInfo.label}</span>
      </Typography>
      
      <LinearProgress 
        variant="determinate" 
        value={passwordStrength} 
        style={{ height: 10, borderRadius: 5, marginBottom: 16, backgroundColor: '#e0e0e0' }}
        color={passwordStrength === 100 ? "primary" : "secondary"}
      />

      {Object.entries(rules).map(([key, rule]) => (
        <div key={key} className={classes.progressContainer}>
          {rule.valid ? 
            <Check style={{ color: '#4BCA81' }} fontSize="small" /> : 
            <Close style={{ color: '#FF0033' }} fontSize="small" />
          }
          <Typography
            className={`${classes.smFont} ${
              rule.valid ? classes.valid : classes.invalid
            } `}
            style={{ marginLeft: 8 }}
          >
            {rule.message}
          </Typography>
        </div>
      ))}
    </Box>
  );
};

export { PasswordChecklist };
